export const conditionsKeys = {
    all: ["medicals", "conditions"] as const,
    conditions: () => [...conditionsKeys.all] as const,
    condition: (id: string) => [...conditionsKeys.conditions(), id] as const,
  } as const;

  export const allergiesKeys = {
    all: ["medicals", "allergies"] as const,
    allergies: () => [...allergiesKeys.all] as const,
    allergy: (id: string) => [...allergiesKeys.allergies(), id] as const,
  } as const;

  export const medicationsKeys = {
    all: ["medicals", "medications"] as const,
    medications: () => [...medicationsKeys.all] as const,
    activeMedications: () => [...medicationsKeys.all, "active"] as const,
    medication: (id1: string, id2:string) => [...medicationsKeys.medications(), id1, id2] as const,
    refills: (id1: string, id2:string) => [...medicationsKeys.medications(), id1, id2] as const,
    refill: (id?: string) => [...medicationsKeys.medications(), "refill", id] as const,
    prescription: (id?: string) => [...medicationsKeys.medications(), id] as const,
    prescriptionMedication: (prescriptionId:string, medicationId:string) => [...medicationsKeys.medications(), prescriptionId, medicationId] as const,
    prescriptions: () => [...medicationsKeys.medications(), "payment"] as const,
    refillHistory: () => [...medicationsKeys.all, "refill", "history"] as const,
    refillProcessing: () => [...medicationsKeys.all, "refill", "processing"] as const,
  } as const;
  
  